import { WidgetType } from 'shared/widgets/utils';

import QuestionGroupListPreviewImage from './resources/question-group-list.svg';
import { QuestionGroupList } from '@/icons/QuestionGroupList';
import { ManifestType } from '@/types/ManifestType';
import { createNewQuestionGroupList } from '@/widgets/QuestionGroupList/create';
import { manifestLocales } from '@/widgets/QuestionGroupList/manifest.locales';

export const Manifest: ManifestType = {
  name: WidgetType.QuestionGroupList,
  previewGroups: [
    {
      id: 'questionGroupList',
      divider: {
        icon: QuestionGroupList,
        title: 'questionGroupList'
      },
      previews: [
        {
          name: 'questionGroupList',
          previewImage: {
            paths: {
              en: QuestionGroupListPreviewImage,
              he: QuestionGroupListPreviewImage
            },
            size: {
              width: 140,
              height: 122
            },
            alt: { ...manifestLocales.questionGroupList.previewImageAlt }
          },
          initializeProps: createNewQuestionGroupList,
          dimensions: {
            width: 1180,
            height: 'auto'
          }
        }
      ]
    }
  ],
  additionalData: {
    constraints: {
      minHeight: 48,
      minWidth: 100
    }
  }
};
